import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import PublicPageShell, { BulletList, SectionHeading } from '@/components/PublicPageShell';
import { Trophy, CheckCircle2 } from 'lucide-react';

export default function ForPlayers() {
  const navigate = useNavigate();
  return (
    <PublicPageShell
      eyebrow="FOR PLAYERS"
      title="Free. Forever. No exceptions."
      intro="Build your verified rugby story, get discovered by scouts, and access the same development tools as professional academies — at zero cost."
      dataTestId="for-players-page"
    >
      <div className="bg-[#0a0a0a] border border-[#A3FF00]/30 rounded-2xl p-7 mb-10" data-testid="player-pricing-banner">
        <div className="flex items-center gap-4">
          <Trophy className="w-10 h-10 text-[#A3FF00] shrink-0" />
          <div>
            <p className="text-3xl font-heading font-bold text-white">FREE</p>
            <p className="text-zinc-400 text-sm">Always. No tier limits. No upsells.</p>
          </div>
        </div>
      </div>

      <SectionHeading>What you get</SectionHeading>
      <BulletList items={[
        "Create a verified, living rugby profile — your stats, your story, your footage.",
        "Get discovered by scouts, academies, and provincial unions across South Africa.",
        "Track your development with your <strong>Player Development Score (PDS)</strong>.",
        "Access <strong>XV Assist AI</strong> for personalised training plans and drill recommendations.",
        "Apply for opportunities: academies, representative trials, development programmes.",
        "List specific needs (boots, kit, transport) on the community fundraising marketplace.",
        "5% off all rugby gear at World of Rugby / TryAndScore — use code <span class='text-[#A3FF00] font-mono font-bold'>FUTUREXV</span>.",
      ]} />

      <SectionHeading>Why this matters</SectionHeading>
      <div className="space-y-4 text-zinc-300 leading-relaxed">
        <p>
          A player with no digital profile, no verified stats, and no footage cannot approach a scout, apply for an
          academy, or prove their development. The system has been entirely dependent on someone else noticing them.
          Most talented players are never noticed.
        </p>
        <p>
          FutureXV gives every player a voice. Whether you play in Mdantsane or Sandton, your profile is searchable,
          your stats are verified, and your development is measurable. <strong className="text-white">No player left behind.</strong>
        </p>
      </div>

      <div className="mt-14 flex flex-wrap gap-3">
        <Button onClick={() => navigate('/auth?role=player')} className="bg-[#A3FF00] hover:bg-[#88dd00] text-black font-bold px-8 py-6" data-testid="players-join-cta">
          <CheckCircle2 className="w-5 h-5 mr-2" />Join as Player — Free
        </Button>
        <Button onClick={() => navigate('/features')} variant="outline" className="border-zinc-700 text-zinc-200 hover:bg-zinc-900 px-8 py-6">
          See all features
        </Button>
      </div>
    </PublicPageShell>
  );
}
